var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconAlert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 4.85714C12.789 4.85714 13.4286 5.49674 13.4286 6.28571V13.4286C13.4286 14.2176 12.789 14.8571 12 14.8571C11.211 14.8571 10.5714 14.2176 10.5714 13.4286V6.28571C10.5714 5.49674 11.211 4.85714 12 4.85714ZM12 19.1429C12.8679 19.1429 13.5715 18.5033 13.5715 17.7143C13.5715 16.9253 12.8679 16.2857 12 16.2857C11.1322 16.2857 10.4286 16.9253 10.4286 17.7143C10.4286 18.5033 11.1322 19.1429 12 19.1429Z",
    fill: "#FFC227"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/iconAlert.b23a06c59f8eafc65977160754927ed9.svg";
export { ForwardRef as ReactComponent };